const SET_RETAILER = 'src/retailer/SET_RETAILER' as const;
const SET_RETAILER_PLATFORM_DETAILS = 'src/retailer/SET_RETAILER_PLATFORM_DETAILS' as const;

export default {
  SET_RETAILER,
  SET_RETAILER_PLATFORM_DETAILS
};
